import { render } from "./contact.vue?vue&type=template&id=05be16b8&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=05be16b8&lang=scss&scoped=true"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05be16b8"]])

export default __exports__